/* Blisko — interakcje motywu */
(function () {
  var BL = window.BL || {};
  var routes = BL.routes || { root: '/', cart: '/cart', add: '/cart/add.js' };

  function money(cents) {
    try {
      return new Intl.NumberFormat('pl-PL', { style: 'currency', currency: BL.currency || 'PLN' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' zł';
    }
  }

  /* pasek informacyjny — rotacja na mobile */
  var ann = document.querySelector('[data-bl-ann]');
  if (ann) {
    var items = ann.querySelectorAll('.bl-ann__item');
    var i = 0;
    if (items.length > 1) setInterval(function () {
      items[i].classList.remove('is-on');
      i = (i + 1) % items.length;
      items[i].classList.add('is-on');
    }, 4000);
  }

  /* nagłówek — linia po przewinięciu */
  var header = document.querySelector('[data-bl-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* menu na telefonie */
  var drawer = document.querySelector('[data-bl-drawer]');
  var openBtn = document.querySelector('[data-bl-menu-open]');
  if (drawer && openBtn) {
    var setMenu = function (open) {
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.classList.toggle('bl-lock', open);
      if (open) { var c = drawer.querySelector('.bl-drawer__top [data-bl-menu-close]'); if (c) c.focus(); }
      else { openBtn.focus({ preventScroll: true }); }
    };
    openBtn.addEventListener('click', function () { setMenu(true); });
    drawer.querySelectorAll('[data-bl-menu-close], .bl-drawer__nav a').forEach(function (el) {
      el.addEventListener('click', function () { setMenu(false); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) setMenu(false); });
  }

  /* karuzela (opinie) — przewijanie palcem + strzałki */
  document.querySelectorAll('[data-bl-slider]').forEach(function (slider) {
    var track = slider.querySelector('[data-bl-track]');
    var nav = slider.querySelector('[data-bl-nav]');
    var prev = slider.querySelector('[data-bl-prev]');
    var next = slider.querySelector('[data-bl-next]');
    var label = slider.querySelector('[data-bl-count-label]');
    if (!track) return;
    var cards = track.children;
    function step() { return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth; }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (nav) nav.hidden = max <= 4;
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= max - 4;
      if (label && cards.length) {
        var i = Math.min(cards.length, Math.round(track.scrollLeft / step()) + 1);
        if (track.scrollLeft >= max - 4) i = cards.length;
        label.textContent = i + ' / ' + cards.length;
      }
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(update, 60); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* pojawianie się sekcji */
  var reveals = document.querySelectorAll('.bl-reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* produkt */
  document.querySelectorAll('[data-bl-product]').forEach(function (sec) {
    var form = sec.querySelector('[data-bl-form]');
    if (!form) return;
    var cta = form.querySelector('[data-bl-cta]');
    var err = form.querySelector('[data-bl-err]');
    var totals = sec.querySelectorAll('[data-bl-total]');
    var sticky = sec.querySelector('[data-bl-sticky]');
    var stickyCta = sec.querySelector('[data-bl-sticky-cta]');

    /* galeria */
    var main = sec.querySelector('[data-bl-main]');
    var thumbs = sec.querySelectorAll('[data-bl-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        if (main) { main.removeAttribute('srcset'); main.src = t.getAttribute('data-bl-thumb'); }
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    function picked() { return form.querySelector('input[name="id"]:checked'); }
    if (!picked()) { var first = form.querySelector('input[name="id"]:not([disabled])'); if (first) first.checked = true; }

    function sync() {
      var p = picked();
      var sum = p ? parseInt(p.getAttribute('data-price') || '0', 10) : 0;
      form.querySelectorAll('[data-bl-addon]:checked').forEach(function (a) { sum += parseInt(a.getAttribute('data-price') || '0', 10); });
      totals.forEach(function (el) { el.textContent = money(sum); });
      var q = form.querySelector('[data-bl-qtyfield]');
      if (q && p) q.value = p.getAttribute('data-qty') || '1';
    }
    form.addEventListener('change', sync);
    sync();

    function showErr(msg) { err.textContent = msg; err.hidden = false; }

    function addToCart() {
      err.hidden = true;
      var p = picked();
      if (!p) { showErr('Wybierz zestaw, aby kontynuować.'); sec.scrollIntoView({ behavior: 'smooth' }); return; }
      var items = [{ id: parseInt(p.value, 10), quantity: parseInt(p.getAttribute('data-qty') || '1', 10) }];
      form.querySelectorAll('[data-bl-addon]:checked').forEach(function (a) {
        items.push({ id: parseInt(a.getAttribute('data-variant'), 10), quantity: 1 });
      });
      cta.setAttribute('aria-busy', 'true');
      if (stickyCta) stickyCta.setAttribute('aria-busy', 'true');
      fetch(routes.add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.d && res.d.description ? res.d.description : 'Nie udało się dodać do koszyka.');
          window.location.href = BL.skipCart ? '/checkout' : routes.cart;
        })
        .catch(function (e) {
          cta.removeAttribute('aria-busy');
          if (stickyCta) stickyCta.removeAttribute('aria-busy');
          showErr(e.message || 'Wystąpił błąd. Spróbuj ponownie.');
        });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(); });
    if (stickyCta) stickyCta.addEventListener('click', addToCart);

    /* sticky pasek — po przewinięciu poza przycisk */
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', past);
        sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
        if (stickyCta) stickyCta.tabIndex = past ? 0 : -1;
      }).observe(cta);
    }
  });
})();
